<section >
  <div class="container-style mb-2">
    <div class="row">
        <div class="col-6">
          <p class="mb-0">
            <b>Sincronización con Siesa de clientes, obras, artículos y movimientos de inventario (entradas, salidas y traslados).</b>
          </p>
        </div>
        <div class="col-6 d-flex justify-content-end gap-2">
          <app-custom-button [title]="'Sincronizar'" [label]="'Sincronizar'" [severity]="'primary'" [variant]="undefined"
            [icon]="'pi pi-sync'" [width]="'7rem'" [disabled]="isSynchronizing || hasSynchronized"
            (onClick)="syncUp()"></app-custom-button>
        </div>
      </div>
  </div>
  <div *ngIf="isSynchronizing || alerts.length > 0 || hasSynchronized || errorMessage" class="container-style">

    <div *ngIf="isSynchronizing" class="mb-3">
      <p class="mb-2"><strong>Sincronizando movimientos...</strong></p>
      <app-custom-progress-bar [show]="true" [heightProgress]="'0.8rem'"></app-custom-progress-bar>
    </div>

    <div *ngIf="alerts.length > 0" class="response-list mb-3">
      <p class="mb-2"><strong>Respuesta del servicio</strong></p>
      <hr class="my-2">
      <p *ngFor="let alert of alerts" class="response-message" [class.text-danger]="alert.alertType === 1">
        {{ alert.message }}
      </p>
    </div>
    <p *ngIf="hasSynchronized && alerts.length === 0" class="mb-3">
      El servicio no retornó mensajes para mostrar.
    </p>
    <p *ngIf="errorMessage" class="text-danger mb-3">{{ errorMessage }}</p>
  </div>
</section>